module.exports = __webpack_public_path__ + "img/pokedex.2e0340ff.png";